<template lang="pug">
  form.form
    h2.h2.new-activity-info__title Добавить билеты

    a(href="#" @click.prevent="allSectors").btn.btn--light-blue.all-sectors-link
      svgicon(name='arrow-line')
      |Все сектора
    .sector
      .sector__left
        h2.h2 {{ this.newSector.name }}
        template
          .sector-row(v-if="rows.length" v-for="row in rows.slice().reverse()")
            .sector-row__title Ряд {{ row.id }}
            .sector-row__content
              a(href="#"
                v-for="place in row.places"
                @click.prevent='editPlace(row, place)'
                :class="{ active: place.isActive, \
                    'place-sector--locked': place.status == 'locked', \
                    'place-sector--sale': place.status == 'sale', \
                    'place-sector--saled': place.status == 'saled', \
                    'place-sector--hide': place.status == 'hide', \
                    'place-sector--reserve': place.status == 'reserve' \
                    }"
                ).sector-row__place.place-sector
                .place-sector__number {{ place.id }}
                .place-sector__price  {{ place.price }}
              a(href="#" @click.prevent="chooseAll(row)" title='Выбрать все места').place-sector.place-sector--new
                svgicon(name='edit')

          p(v-if="rows.length == 0") В этом секторе пока нет ни одного билета.
        .new-activity-info__links
          a(href='#' @click.prevent='showModal = true').btn.tickets__add-sector-link
            svgicon(name='plus')
            | Добавить ряды
      .sector__right(sticky-container)
        div(v-sticky sticky-offset="{top: 10, bottom: 30}" sticky-side="both")
          h2.h2(v-if="this.allTickets.length")  Все билеты  {{ this.allTickets.length}}
          .sector__price(v-if="this.summPrice > 0") Цена: {{ this.summPrice }} Р
          .sector__status
            .sector__status-locked(v-if="this.locked.length")
              svgicon(name='locked')
              |Заблокированы: {{ this.locked.length }}
            .sector__status-sale(v-if="this.sale.length")
              svgicon(name='ticked-sale')
              |Продается: {{ this.sale.length }}
            .sector__status-saled(v-if="this.saled.length")
              svgicon(name='saled')
              |Проданы: {{ this.saled.length }}
            .sector__status-hide(v-if="this.hide.length")
              svgicon(name='hide')
              |Скрыты: {{ this.hide.length }}
            .sector__status-reserve(v-if="this.reserve.length")
              svgicon(name='reserve')
              |Под пригласительные: {{ this.reserve.length }}
          .sector-modal(v-show='showSecModal')
            a(href='#' @click.prevent="modalClose()").modal__close
              svgicon(name='close')
            .sector-modal__title {{ this.viewPlacesString }}
            .sector-modal__text(v-if="this.editRow < 2") Количество:
              span {{ placeCount }}
            .form__group
              label.form__label Статус
              v-select(
                :options=["Продается","Заблокированы","Проданы","Скрыты","Под пригласительные"]
                :clearable="false"
                :searchable="false"
                :placeholder="'Выберите статус'"
                v-model="status"
                ).form__select.form__select--full
            .form__group
              label.form__label Цена
              input(type='text' required v-model="price" @input="onlyNumber(price, 'price')").form__input.form__input--full
            .sector__footer
              a(href="#" @click.prevent="editSave()" :class="{'btn--disabled': !valid()}").btn Сохранить
              a(href="#" @click.prevent="deleteTickets()").btn.btn--nobg Удалить билеты
                svgicon(name='delete')


    button(:class="[{'btn--disabled': !required}]" @click.prevent="allSectors()").btn.btn--big.new-activity-info__next Сохранить

    modal(v-show='showModal' @close='showModal = false')
      h3(slot='header') Добавить ряд
      template(slot='body')
        .form__group
          label.form__label Количество мест в ряду
          input(type='text' required v-model="value" @input="onlyNumber(value)").form__input.form__input--full
      template(slot='footer')
        button.btn(@click.prevent="newRow" :class="{'btn--disabled':this.value.length < 1}" :disabled="this.value.length < 1") Добавить

</template>

<script>
import Modal from '@/components/Modal.vue'

import { mapGetters } from 'vuex';
export default {
  name: 'NewAddTicket',
  components:{
    Modal,
  },
  data() {
    return {
      required: true,
      showModal: false,
      showSecModal: false,
      value: '',
      status: null,
      price: '',
      placeCount: null,
      placeNumber: [],
      rows: [],
      placeActive: [],
      locked: [],
      sale: [],
      saled: [],
      hide: [],
      reserve: [],
      allTickets: [],
      summPrice: 0,
      viewPlacesString: String,
      editRow: 0,
    }
  },
  mounted() {
    if(this.newSector.scheme !== null && this.newSector.scheme !== '') {
      this.rows = this.newSector.scheme;
      this.rows.forEach(element => {
        this.allTickets = this.allTickets.concat(element.places);
        this.placeActive.push({rowId: element.id, places: []});
        this.placeNumber.push({rowId: element.id, places: []});
      });
      this.update();
    }
  },
  methods: {
    onlyNumber(data, name){
      if( name == 'price'){
        this.price = data.replace(/[^\d]/g,'');
      }
      return this.value = data.replace(/[^\d]/g,'');
    },
    valid() {
      return this.price.length > 0  || this.status != null
    },
    nextStep: function(){
      if(this.required) {
        return this.$router.push({ name: 'tickets' })
      }
    },
    allSectors(){
      this.addSectorInSectors();
      this.$router.push({ name: 'tickets' })
    },
    addSectorInSectors(){
      const copySector = Object.assign({}, this.newSector);
      const copyRows = this.rows.slice();
      copySector['scheme'] = copyRows;
      const res = this.sectors.find(item => item.id === copySector.id);
      const index = this.sectors.findIndex(item => item.id === copySector.id);
      if(res !== undefined) {
        this.sectors.splice(index, 1, copySector)
      } else {
        this.sectors.splice(0,0, copySector)
      }
      return false;
    },
    newRow: function() {
      const placeArr = [];
      for (let index = 0; index < this.value; index++) {
        placeArr.push(
          {
            id: index+1,
            price: '-',
            isActive: false,
            status: '',
          }
        )
      }
      this.rows.push({id: this.rows.length + 1, places: placeArr});
      this.placeActive.push({rowId: this.rows.length, places: []});
      this.placeNumber.push({rowId: this.rows.length, places: []});
      this.allTickets = this.allTickets.concat(placeArr)
      this.value = '';
      this.update();
      this.showModal = false;
    },
    editPlace: function(row, place) {
      this.status = null;
      this.price = '';
      if(place.isActive) {
        let currentEl_inArray = this.placeActive[row.id - 1].places.findIndex(item => item.placeId == place.id)
        this.placeActive[row.id - 1].places.splice(currentEl_inArray, 1);
        this.placeNumber[row.id - 1].places.splice(this.placeNumber[row.id - 1].places.indexOf(place.id),1);
      } else {
        this.placeActive[row.id - 1].places.push({placeId: place.id});
        this.placeNumber[row.id - 1].places.push(place.id);
        this.placeNumber[row.id - 1].places.sort(function(a, b) {
          return a - b;
        });
      }
      place.isActive = !place.isActive;
      this.showSecModal = true;
      this.placeCount = this.placeCountFn();
      this.placeEditFn();
      if(this.placeCount < 1) {
        this.showSecModal = false;
      }
    },
    placeCountFn(){
      let result = 0;
      this.placeActive.forEach(element => {
        result += element.places.length
      });
      return result;
    },
    placeEditFn(){
      let activeRow = 0;
      this.placeActive.forEach((element, index) => {
        if(element.places.length > 0) {
          activeRow += 1;
          this.editRow = activeRow;
          this.viewPlaces(activeRow, index)
        }
      });
      activeRow = 0;
    },
    editSave() {
      if(this.valid()) {
        let tickedStatus;
        if(this.status === 'Заблокированы') {
          tickedStatus = 'locked';
        }
        if(this.status === 'Продается') {
          tickedStatus = 'sale';
        }
        if(this.status === 'Проданы') {
          tickedStatus = 'saled';
        }
        if(this.status === 'Скрыты') {
          tickedStatus = 'hide';
        }
        if(this.status === 'Под пригласительные') {
          tickedStatus = 'reserve';
        }
        for (let index = 0; index < this.placeActive.length; index++) {
          const element = this.placeActive[index];
          let curRow = this.rows.findIndex(item => item.id == element.rowId);
          for (let index = 0; index < element.places.length; index++) {
            const el = element.places[index];
            let curPlace = this.rows[curRow].places.find(item => item.id == el.placeId);
            curPlace.price = this.price || '-';
            curPlace.status = tickedStatus;
            curPlace.isActive = false;
          }
        }

        this.update();
        this.modalClose();
      }
    },
    update() {
      this.locked = [];
      this.sale = [];
      this.saled = [];
      this.allTickets = [];
      this.summPrice = 0;
      this.newSector.summ = 0;
      this.newSector.status = [];
      this.newSector.price = [];
      for (let index = 0; index < this.rows.length; index++) {
        const rowIndex = index;
        for (let index = 0; index < this.rows[rowIndex].places.length; index++) {
          const place = this.rows[rowIndex].places[index];
          switch (place.status) {
            case 'locked':
              this.locked.push(place)
              break;
            case 'sale':
              this.sale.push(place)
              break;
            case 'saled':
              this.saled.push(place)
              break;
            case 'reserve':
              this.reserve.push(place)
              break;
            case 'hide':
              this.hide.push(place)
              break;
            default:
              break;
          }

          if(!this.newSector.status.includes(place.status)) {
            if(place.status !== '' && place.status !== undefined){
              this.newSector.status.push(place.status);
            }
          }
          this.allTickets.push(place);
          if ( !isNaN(place.price) ) {
            this.summPrice += parseInt(place.price);

            if(!this.newSector.price.includes(parseInt(place.price))) {
              this.newSector.price.push(parseInt(place.price));
            }
          }
        }
      }
      this.rows.forEach(element => {
        element.places.forEach(el => {
          el.isActive = false;
        });
      });
      this.placeActive.forEach(element => {
        element.places = [];
      });
      this.placeNumber.forEach(element => {
        element.places = [];
      });


      let rows = [];
      for (let i = 0; i < this.rows.length; i++) {
        rows.push(i + 1)
      }
      this.newSector.summ = this.summPrice;
      this.newSector.row = rows;
      this.newSector.place = this.allTickets.length;
    },
    deleteTickets() {
      for (let index = 0; index < this.placeActive.length; index++) {
        const element = this.placeActive[index];
        let curRow = this.rows.findIndex(item => item.id == element.rowId);
        for (let index = 0; index < element.places.length; index++) {
          const el = element.places[index];
          let curPlace = this.rows[curRow].places.findIndex(item => item.id == el.placeId);
          this.rows[curRow].places.splice(curPlace,1);
        }
      }
      this.update();
      this.modalClose();
    },
    shortView(x) {
      let skip = 0;
      return x.reduce((prev, cur, i, arr) => {
          skip = arr[i + 1] - arr[i] !== 1 ? 0 : skip + 1;
          if (skip > 1) {
              return prev.slice(0, -1) + "-";
          }
          return prev.concat(cur + ",");
      }, "").slice(0, -1)
    },
    viewPlaces(activeRow, curRow){
      if(activeRow > 1) {
        this.viewPlacesString = `Выбрано ${this.placeCount} мест(а), в ${activeRow} рядах`
      } else {
        this.viewPlacesString = 'Места №: ' + this.shortView(this.placeNumber[curRow].places);
      }
      return this.viewPlacesString;
    },
    modalClose(){
      this.showSecModal = false;
      this.update();
    },
    chooseAll(row){
      row.places.forEach(item => {
        this.editPlace(row, item);
      });
    }
  },
  computed: {
    ...mapGetters([
      'newSector',
      'sectors',
    ]),
  }
}
</script>

<style lang="scss">
.new-activity-steps{
  padding: 40px 40px;
  background-color: #008cff;
  background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
  &__title{
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__content{
    display: flex;
  }
  &__steps{
    display: flex;
    margin-right: 35px;
  }
  &__step{
    width: 50px;
    height: 50px;
    border: 1px solid rgba(#fff, 0.5);
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 26px;
    margin-right: 20px;
    border-radius: 50%;
    &.active{
      background-color: #fff;
      border-color: #fff;
      color: #161616;
    }
  }
  &__text{
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
  }
}
.new-activity-info{
  padding: 0px 40px;
  margin: 30px 0 40px;
  &__title{
    margin-top: 0;
  }
  &__content{
    display: flex;
    margin-bottom: 20px;
  }
  &__links{
    margin-bottom: 20px;
  }
}
.tickets__add-sector-link{
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  .svg-icon{
    margin-right: 10px;
    width: 14px;
    height: 14px;
  }
}
.all-sectors-link{
  display: inline-flex;
  align-items: center;
  .svg-icon{
    width: 15px;
    height: 12px;
    margin-right: 12px;
  }
}
.sector{
  margin-bottom: 40px;
  display: flex;
  &__left{
    width: 880px;
    margin-right: 40px;
  }
  &__right{
    width: 390px;
  }
  .h2{
    margin-bottom: 20px;
  }
  &__h3{
    font-weight: 700;
  }
  p{
    color: #161616;
    font-size: 16px;
  }
  &__price{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__status{
    margin-bottom: 30px;
    &-locked,
    &-sale,
    &-saled,
    &-reserve,
    &-hide{
      color: #161616;
      font-size: 14px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
    }
    &-locked{
      .svg-icon{
        width: 28px;
        height: 25px;
        color: #9398a2;
        margin-right: 13px;
        display: block;
      }
    }
    &-sale{
      .svg-icon{
        width: 28px;
        height: 17px;
        color: #78c076;
        margin-right: 13px;
        display: block;
      }
    }
    &-saled{
      .svg-icon{
        width: 28px;
        height: 17px;
        color: #ffcc00;
        margin-right: 13px;
        display: block;
      }
    }
    &-hide{
      .svg-icon{
          width: 28px;
          height: 25px;
          color: #b533eb;
          margin-right: 13px;
          display: block;
      }
    }
    &-reserve{
      .svg-icon{
          width: 28px;
          height: 25px;
          color: #008cff;
          margin-right: 13px;
          display: block;
      }
    }
  }
  &-modal{
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    background-color: #fff;
    padding: 20px;
    margin-top: 30px;
    position: relative;
    &__close{
      position: absolute;
      top: 20px;
      right: 20px;
      width: 16px;
      height: 16px;
      color: #161616;
      &:hover{
        color: #008cff;
        .svg-icon{
          transform: rotate(180deg);
        }
      }
      .svg-icon{
        display: block;
        transition: transform 0.35s;
      }
    }
    &__title{
      color: #161616;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 18px;
    }
    &__text{
      color: #161616;
      font-size: 16px;
      margin-bottom: 15px;
    }
  }
  &-row{
    border-bottom: 1px solid #e4e4e4;
    margin-bottom: 20px;
    &:last-child{
      border-bottom: none;
      margin-bottom: 0;
    }
    &__title{
      color: #161616;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 15px;
    }
    &__content{
      margin: 0 -10px;
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.place-sector{
  margin: 0 9px 20px;
  text-align: center;
  text-decoration: none;
  display: block;
  &.active,
  &:hover{
    .place-sector__number{
      border-color: #008cff;
    }
  }
  &__number {
    border: 1px solid #e4e4e4;
    background-color: #fff;
    width: 42px;
    height: 42px;
    text-align: center;
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    border-radius: 50%;
    margin-bottom: 7px;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  &__price{
    color: #161616;
    font-size: 14px;
  }
  &--new{
    color: #fff;
    background-color: #7b7b7b;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    .svg-icon{
      width: 22px;
    }
    &:hover{
      background: #008cff;
      color: #fff;
    }
  }
  &--sale{
    .place-sector__number{
      border: 3px solid #78c076;
    }
    &.active,
    &:hover{
      .place-sector__number{
        border: 3px solid #78c076;
        background: #78c076;
      }
    }
  }
  &--saled{
    .place-sector__number{
      border: 3px solid #ffcc00;
    }
    &.active,
    &:hover{
      .place-sector__number{
        border: 3px solid #ffcc00;
        background: #ffcc00;
      }
    }
  }
  &--locked{
    .place-sector__number{
      border: 3px solid #eee;
      background: #eee;
    }
    &.active,
    &:hover{
    .place-sector__number{
      border-color: #7b7b7b;
    }
    }
  }

  &--hide{
        .place-sector__number{
            border: 3px solid #b533eb;
        }
        &.active,
        &:hover{
            .place-sector__number{
                border: 3px solid #b533eb;
                background: #b533eb;
            }
        }
  }

  &--reserve{
        .place-sector__number{
            border: 3px solid #008cff;
        }
        &.active,
        &:hover{
            .place-sector__number{
                border: 3px solid #008cff;
                background: #008cff;
            }
        }
  }
}

@media (max-width: 1339px) {
  .sector-modal{
    flex-shrink: 0;
    width: 330px;
  }
}

@media (max-width: 991px) {
  .new-activity-info {
    padding: 0 20px;
  }
  .sector{
    flex-direction: column;
  }
  .sector__left{
    width: 100%;
    margin-right: 0;
  }
  .sector__right{
    width: 100%;
  }
  .sector-modal{
    box-sizing: border-box;
    width: 100%;
    .form__input{
      width: 100%;
    }
  }
}
@media (max-width: 767px) {
  .new-activity-steps {
    padding: 20px;
  }
  .new-activity-steps__content{
    flex-direction: column;
  }
  .new-activity-steps__steps {
    margin-bottom: 20px;
    margin-right: 0;
  }
  .new-activity-steps__text {
    font-size: 14px;
    line-height: 20px;
  }
  .modal{
    max-width: 100%;
    box-sizing: border-box;
    .form__input{
      width: 100%;
    }
  }
}

@media (max-width: 479px) {
  .sector__footer{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .btn--nobg{
      margin-left: 0;
      margin-top: 10px;
    }
  }
}

</style>